import { render, staticRenderFns } from "./report-card-khmer.vue?vue&type=template&id=e84e8dde&"
import script from "./report-card-khmer.vue?vue&type=script&lang=js&"
export * from "./report-card-khmer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports